import { useEffect, useState } from 'react';
import { MessagePayload, onMessage } from 'firebase/messaging';
// import { messaging } from './firebase-config';
// Xác định kiểu của thông báo
interface NotificationPayload {
    title: string,
    body: string
}
const useNotificationListener = () => {
    const [notification, setNotification] = useState<NotificationPayload | null>(null);

    // useEffect(() => {
    //     const unsubscribe = onMessage(messaging, (payload: MessagePayload) => {
    //         console.log('Message received. ', payload);
    //         setNotification({
    //             title: payload.notification?.title || 'title',
    //             body: payload.notification?.body || 'body'
    //         });
    //     });

    //     return () => unsubscribe();
    // }, []);

    return notification;
};

export default useNotificationListener;
